module.exports = "<div [@changeState]=\"currentState\" class=\"myblock mx-auto\">\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/dant/dant.component.html
// module id = ./src/app/dant/dant.component.html
// module chunks = main